export const getNameInitials = (name = '') => {
  const nameInitials = name.split(' ').reduce((a, item) => a + item.charAt(0), '')

  return nameInitials.toUpperCase().substring(0, 2)
}
